export default class Admin {
  constructor(){
    switch (window.location.origin){
      case "https://pubmanager.n2pub.com":
        this.apiDomain = 'https://pubmanagerapi.n2pub.com'
        break;
      default:
        this.apiDomain = window.location.origin
        break;
    }
  }

  index() {
    $.get('/sidekiq_queue_latency', () => {}).always((resp) => {
      if (resp == "OK") {
        $('.js-sidekiq-latency').addClass('green-text').text('OK')
      } else {
        $('.js-sidekiq-latency').addClass('red-text').text('VERY DELAYED')
      }
    })

    $.get('/sidekiq_queue_size', () => {}).always((resp) => {
      if (resp == "OK") {
        $('.js-sidekiq-size').addClass('green-text').text('OK')
      } else {
        $('.js-sidekiq-size').addClass('green-text').text('GETTING LARGE')
      }
    })

    $.ajax({
      url: `${this.apiDomain}/api/v1/up`,
      type: 'GET',
      dataType: 'json'
      }).always((resp) => {
        if (resp.status == "OK") {
          $('.js-api-status').addClass('green-text').text('OK')
        } else {
          $('.js-api-status').addClass('red-text').text('DOWN')
        }
    })
  }
}
